"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsAndStandingsProperty = exports.resultsAndStandingsPropertyDefinition = void 0;
exports.resultsAndStandingsPropertyDefinition = {
    view: { label: 'Results and Standings' },
    constraints: [
        {
            name: 'stencils',
            argument: ['results-and-standings'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'results-and-standings',
};
const isResultsAndStandingsProperty = (prop) => {
    return prop.name === exports.resultsAndStandingsPropertyDefinition.name;
};
exports.isResultsAndStandingsProperty = isResultsAndStandingsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy1hbmQtc3RhbmRpbmdzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy1hbmQtc3RhbmRpbmdzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLHVCQUF1QixFQUFFO0lBQ3hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsdUJBQXVCLENBQUM7U0FDcEM7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsdUJBQXVCO0NBQ0UsQ0FBQTtBQUkxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9